<template>
  <div>
    <logged-in-header />
    <operators-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import operatorsPanel from "../components/operators/OperatorsPanel";

export default {
  components: {
    loggedInHeader,
    operatorsPanel
  }
};
</script>
